import './purpose.scss';
import 'animate.css';

import '@fortawesome/fontawesome-svg-core/styles.css';

import * as Sentry from '@sentry/react';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { filterMessage, filterTransaction } from '@furality/frontend-stack';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx';
import gitVersionInfo from './lib/generatedGitInfo.json' with { type: 'json' };
// Import the generated route tree
import { routeTree } from './routeTree.gen.ts';

Sentry.init({
  dsn:
    import.meta.env.PUBLIC_SENTRY_DSN ||
    'https://038b88cd092c31a24c9e8607283a073d@o4506039478583296.ingest.us.sentry.io/4506094041432064',
  tracesSampleRate: 1,
  debug: true,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  maxBreadcrumbs: 32,
  beforeSend: filterMessage,
  beforeSendTransaction: filterTransaction,
  release: gitVersionInfo.releaseName,
});

const TanStackQueryProviderContext = TanStackQueryProvider.getContext();

const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  // interface merging
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
        <RouterProvider router={router} />
      </TanStackQueryProvider.Provider>
    </StrictMode>,
  );
}
